import { render, staticRenderFns } from "./proyectos2.vue?vue&type=template&id=967a1f24"
import script from "./proyectos2.vue?vue&type=script&lang=js"
export * from "./proyectos2.vue?vue&type=script&lang=js"
import style0 from "./proyectos2.vue?vue&type=style&index=0&id=967a1f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports